import { Form } from '@kocsistem/oneframe-react-bundle';
import { Popper, Tooltip } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { ReactComponent as SelectIcon } from '../../../_assets/images/select-icon.svg';
import CustomReactDatePicker from '../../../components/custom-react-datepicker';
import { del, get, post } from '../../../core/client';
import { useAppSelector } from '../../../store';
import { getEvents } from '../../../store/features/moments/momentsSlice';
import DeleteWarningModal from './deleteWarningModal';
import EditActionForm from './editActionForm';
import ModalDialog from './modal';
import ModalCreateActions from './modalCreateActions';

export default function CreateActionForm() {
    const dispatch = useDispatch();
    const { page, filter } = useAppSelector(state => state.moments);
    const { words } = useAppSelector(state => state.localization);
    const initialState = {
        managerDefinedSpecialDateId: null, //momentId
        userSpecialDateMainId: null,
        actionId: '',
        otherActionDescription: '',
        location: '',
        actionDate: null,
        actionTime: '',
        description: '',
    };

    const [state, setState] = useState<any>(initialState);
    const [showCreateActionForm, setShowCreateActionForm] = useState<boolean>(false);
    const [openStartDatePicker, setStartOpenDatePicker] = useState<boolean>(false);
    const [specialDateOptions, setSpecialDateOptions] = useState<Array<any>>([]);
    const [isOtherShow, setIsOtherShow] = useState<boolean>(false);
    const [actionTime, setActionTime] = useState<string>('');
    const [actionTimeOptions, setActionTimeOptions] = useState<any>([]);
    const [locationOptions, setLocationOptions] = useState<any>([]);
    const [definedActions, setDefinedActions] = useState<Array<any>>([]);
    const [showModal, setShowModal] = useState<boolean>(false);
    const [showModalAction, setShowModalAction] = useState<boolean>(false);
    const [isTouched, setIsTouched] = useState<boolean>(false);
    const [deleteId, setDeleteId] = useState<any>('');
    const [editedActionId, setEditedActionId] = useState<string>('');
    const [editedActionState, setEditedActionState] = useState<any>(null);
    const [isEditedActionTouched, setIsEditedActionTouched] = useState<boolean>(false);
    const [showEditActionForm, setShowEditActionForm] = useState<boolean>(false);
    const [planValue, setPlanValue] = useState<any>(null);
    const [deleteWraningModal, setDeleteWraningModal] = useState<boolean>(false);

    useEffect(() => {
        if (page.managerDefinedSpecialDateId || page.userSpecialDateMainId) {
            const id = page.managerDefinedSpecialDateId ? page.managerDefinedSpecialDateId : page.userSpecialDateMainId;
            const queryParam = (page.managerDefinedSpecialDateId ? '?ManagerDefinedSpecialDateId=' : '?UserSpecialDateMainId=') + id;
            const getDetails = async () => {
                const response = await get<any>(`/specialdate-action/get-special-date-action-list${queryParam}`);
                setDefinedActions(response.result.actionList);
                setShowCreateActionForm(response.result.actionList.length === 0);
                const options = [];

                for (let i = 0; i < response.result.optionList.length; i++) {
                    const option = response.result.optionList[i];
                    if (option.name) {
                        options.push({ value: option.id, label: option.name, isOther: option.isOther });
                    }
                }
                setSpecialDateOptions(options);
            };
            //details
            getDetails();
            setLocationOptions([
                { value: words && words['WEB.outOfOfice'], label: words && words['WEB.outOfOfice'] },
                { value: words && words['WEB.insideOfice'], label: words && words['WEB.insideOfice'] },
            ]);
            setActionTimeOptions([
                { value: '05:00', label: words && words['WEB.choose'] },
                { value: '08:00', label: '08:00' },
                { value: '09:00', label: '09:00' },
                { value: '10:00', label: '10:00' },
                { value: '11:00', label: '11:00' },
                { value: '12:00', label: '12:00' },
                { value: '13:00', label: '13:00' },
                { value: '14:00', label: '14:00' },
                { value: '15:00', label: '15:00' },
                { value: '16:00', label: '16:00' },
                { value: '17:00', label: '17:00' },
                { value: '18:00', label: '18:00' },
                { value: '19:00', label: '19:00' },
                { value: '20:00', label: '20:00' },
                { value: '21:00', label: '21:00' },
                { value: '22:00', label: '22:00' },
                { value: '23:00', label: '23:00' },
                { value: '00:00', label: '00:00' },
            ]);
        }
    }, [page]);

    useEffect(() => {
        if (state.actionId && specialDateOptions.length > 0) {
            setIsOtherShow(specialDateOptions.find(x => x.value === state.actionId).isOther);
        }
    }, [state.actionId]);

    useEffect(() => {
        setPlanValue(specialDateOptions?.length === 1 ? specialDateOptions[0] : '');
        setState(prevState => ({
            ...prevState,
            actionId: specialDateOptions[0]?.value,
        }));
    }, [specialDateOptions]);

    const handleSubmit = async () => {
        const formData = {
            managerDefinedSpecialDateId: page.managerDefinedSpecialDateId, //momentId
            userSpecialDateMainId: page.userSpecialDateMainId,
            actionId: '',
            otherActionDescription: '',
            location: '',
            actionDate: null,
            actionHour: null,
            actionMinute: null,
            description: '',
        };

        setIsTouched(true);

        if (
            !state.actionId
            //  || !state.location
        ) {
            return;
        }

        if (state?.actionDate === '') {
            return;
        }

        if (specialDateOptions.find(x => x.value === state.actionId).isOther) {
            if (!state.otherActionDescription) {
                return;
            }
            formData.otherActionDescription = state.otherActionDescription;
        }

        formData.actionId = state.actionId;
        formData.location = state.location;
        if (state?.actionDate?.length > 0) {
            const month = state.actionDate.getMonth() + 1;
            const day = state.actionDate.getDate();
            const year = state.actionDate.getFullYear();

            formData.actionDate = year + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day);
        }

        if (state.actionTime) {
            formData.actionHour = parseInt(state.actionTime.split(':')[0]);
            formData.actionMinute = parseInt(state.actionTime.split(':')[1]);
        } else {
            (formData.actionHour = 5), (formData.actionMinute = 0);
        }

        formData.description = state.description;

        const endpoint = `/specialdate-action`;
        await post<any>(endpoint, formData, '').then(res => {
            if (res.isSuccessful) {
                const getDetails = async () => {
                    const id = page.managerDefinedSpecialDateId ? page.managerDefinedSpecialDateId : page.userSpecialDateMainId;
                    const queryParam = (page.managerDefinedSpecialDateId ? '?ManagerDefinedSpecialDateId=' : '?UserSpecialDateMainId=') + id;
                    const response = await get<any>(`/specialdate-action/get-special-date-action-list${queryParam}`);
                    dispatch(getEvents(filter));
                    setDefinedActions(response.result.actionList);
                    setShowCreateActionForm(false);
                    setState(initialState);
                    setActionTime('');
                    setIsOtherShow(false);
                    setShowModalAction(true);
                    setIsTouched(false);
                    setPlanValue(null);
                };
                getDetails();
            }
        });
    };

    const handleEditedSubmit = async () => {
        const formData = {
            managerDefinedSpecialDateId: page.managerDefinedSpecialDateId, //momentId
            userSpecialDateMainId: page.userSpecialDateMainId,
            actionId: '',
            otherActionDescription: '',
            location: '',
            actionDate: null,
            actionHour: null,
            actionMinute: null,
            description: '',
            id: editedActionState.id,
            userId: editedActionState.userId,
        };
        setIsEditedActionTouched(true);
        if (
            !editedActionState.actionId
            // || !editedActionState.location
            //  || !editedActionState.actionDate
        ) {
            return;
        }

        if (specialDateOptions.find(x => x.value === editedActionState.actionId).isOther) {
            if (!editedActionState.otherActionDescription) {
                return;
            }
            formData.otherActionDescription = editedActionState.otherActionDescription;
        }

        formData.actionId = editedActionState.actionId;
        formData.location = editedActionState.location;

        if (editedActionState.actionDate === '') {
            return;
        }
        if (editedActionState.actionDate !== null) {
            const month = editedActionState.actionDate.getMonth() + 1;
            const day = editedActionState.actionDate.getDate();
            const year = editedActionState.actionDate.getFullYear();

            formData.actionDate = year + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day);
        }

        if (editedActionState.actionTime) {
            formData.actionHour = parseInt(editedActionState.actionTime.split(':')[0]);
            formData.actionMinute = parseInt(editedActionState.actionTime.split(':')[1]);
        }
        formData.description = editedActionState.description;
        const endpoint = `/specialdate-action/update`;
        await post<any>(endpoint, formData, '').then(res => {
            if (res.isSuccessful) {
                const getDetails = async () => {
                    const id = page.managerDefinedSpecialDateId ? page.managerDefinedSpecialDateId : page.userSpecialDateMainId;
                    const queryParam = (page.managerDefinedSpecialDateId ? '?ManagerDefinedSpecialDateId=' : '?UserSpecialDateMainId=') + id;
                    const response = await get<any>(`/specialdate-action/get-special-date-action-list${queryParam}`);
                    setDefinedActions(response.result.actionList);
                    setShowCreateActionForm(false);
                    setShowEditActionForm(false);
                    setEditedActionId('');
                    setActionTime('');
                    setEditedActionState(null);
                    // setShowModalAction(true);
                };
                getDetails();
            }
        });
    };

    const editWarningOpenModal = () => {
        setDeleteWraningModal(true);
    };

    const handleChange = (e: any) => {
        setState(prevState => ({
            ...prevState,
            [e.target.name]: e.target.value === undefined ? e.target.checked : e.target.value,
        }));
    };

    const actionDeleteId = (id: any) => {
        setShowModal(true);
        const acitonDelete = definedActions.find(x => x.speicalDayActionId === id);
        setDeleteId(acitonDelete);
    };

    const deleteActions = async () => {
        await del(`specialdate-action/delete?id=${deleteId.speicalDayActionId}`, '').then((res: any) => {
            if (res.data.isSuccessful) {
                const getActions = async () => {
                    const id = page.managerDefinedSpecialDateId ? page.managerDefinedSpecialDateId : page.userSpecialDateMainId;
                    const queryParam = (page.managerDefinedSpecialDateId ? '?ManagerDefinedSpecialDateId=' : '?UserSpecialDateMainId=') + id;
                    const response = await get<any>(`/specialdate-action/get-special-date-action-list${queryParam}`);
                    setDefinedActions(response.result.actionList);
                };
                getActions();
            }
        });
        setShowModal(false);
    };
    // Edit action start

    const handleUpdateAction = speicalDayActionId => {
        setEditedActionId(speicalDayActionId);
        setShowCreateActionForm(false);
        setShowEditActionForm(true);
    };
    const CustomPopper2 = function (props) {
        return <Popper {...props} className="modal-10" x-placement="bottom" />;
    };

    return (
        <>
            <ModalCreateActions message={words && words['WEB.cretePlanSuccessfully']} open={showModalAction} setOpen={setShowModalAction} />

            {definedActions.length > 0 &&
                definedActions.map((item, index) => (
                    <>
                        <ModalDialog
                            deleteActions={deleteActions}
                            id={item.speicalDayActionId}
                            message={words && words['WEB.sureToDeletePlan']}
                            open={showModal}
                            setOpen={setShowModal}
                        />

                        <div className="c-section-action" key={'c-section-action' + index}>
                            <div className="micro-content-03">
                                <div className="c-item-01">
                                    <h3 className="c-item-01-A">
                                        {index + 1}. {words && words['WEB.plan']}{' '}
                                    </h3>
                                    <div className="c-item-01-B">
                                        <a href="#!" className="c-unit-01">
                                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M15.8333 3.33331H4.16667C3.24619 3.33331 2.5 4.07951 2.5 4.99998V16.6666C2.5 17.5871 3.24619 18.3333 4.16667 18.3333H15.8333C16.7538 18.3333 17.5 17.5871 17.5 16.6666V4.99998C17.5 4.07951 16.7538 3.33331 15.8333 3.33331Z"
                                                    stroke="white"
                                                    strokeWidth="2"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M13.3335 1.66669V5.00002"
                                                    stroke="white"
                                                    strokeWidth="2"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M6.6665 1.66669V5.00002"
                                                    stroke="white"
                                                    strokeWidth="2"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M2.5 8.33331H17.5"
                                                    stroke="white"
                                                    strokeWidth="2"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                            </svg>
                                        </a>
                                        <span className="c-unit-02">
                                            {item.actionDate === null ? '-' : new Date(item.actionDate).toLocaleDateString('tr-TR')}
                                        </span>

                                        <a href="#!" className="c-unit-01">
                                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M16.6666 10V18.3333H3.33325V10"
                                                    stroke="white"
                                                    strokeWidth="2"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M18.3334 5.83337H1.66675V10H18.3334V5.83337Z"
                                                    stroke="white"
                                                    strokeWidth="2"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M10 18.3334V5.83337"
                                                    stroke="white"
                                                    strokeWidth="2"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M10.0001 5.83329H6.25008C5.69755 5.83329 5.16764 5.6138 4.77694 5.2231C4.38624 4.8324 4.16675 4.30249 4.16675 3.74996C4.16675 3.19743 4.38624 2.66752 4.77694 2.27682C5.16764 1.88612 5.69755 1.66663 6.25008 1.66663C9.16675 1.66663 10.0001 5.83329 10.0001 5.83329Z"
                                                    stroke="white"
                                                    strokeWidth="2"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M10 5.83329H13.75C14.3025 5.83329 14.8324 5.6138 15.2231 5.2231C15.6138 4.8324 15.8333 4.30249 15.8333 3.74996C15.8333 3.19743 15.6138 2.66752 15.2231 2.27682C14.8324 1.88612 14.3025 1.66663 13.75 1.66663C10.8333 1.66663 10 5.83329 10 5.83329Z"
                                                    stroke="white"
                                                    strokeWidth="2"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                            </svg>
                                        </a>
                                        <span className="c-unit-03">{item.name}</span>
                                    </div>
                                </div>

                                {item?.regulatoryAuthorityDescription && (
                                    <DeleteWarningModal
                                        message={item?.regulatoryAuthorityDescription}
                                        open={deleteWraningModal}
                                        setOpen={setDeleteWraningModal}
                                    />
                                )}

                                <div className="c-item-02">
                                    <Tooltip placement="top" arrow title={words && words['WEB.editPlan']} className="c-item-02-B">
                                        <button
                                            onClick={() =>
                                                item?.hasRegulatoryAuthority ? handleUpdateAction(item.speicalDayActionId) : editWarningOpenModal()
                                            }
                                            className="c-item-02-A">
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M18 2L22 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                <path
                                                    d="M7.5 20.5L19 9L15 5L3.5 16.5L2 22L7.5 20.5Z"
                                                    stroke="white"
                                                    strokeWidth="2"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                            </svg>
                                        </button>
                                    </Tooltip>
                                    <Tooltip placement="top" arrow title={words && words['WEB.deletePlan']} className="c-item-02-B">
                                        <button
                                            onClick={() =>
                                                item?.hasRegulatoryAuthority ? actionDeleteId(item.speicalDayActionId) : editWarningOpenModal()
                                            }
                                            className="c-item-02-A">
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M3 6H5H21" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                <path
                                                    d="M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6H19Z"
                                                    stroke="white"
                                                    strokeWidth="2"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path d="M10 11V17" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                <path d="M14 11V17" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                        </button>
                                    </Tooltip>
                                </div>
                            </div>
                        </div>
                        {showEditActionForm && item.speicalDayActionId === editedActionId && (
                            <EditActionForm
                                definedActions={definedActions}
                                id={editedActionId}
                                specialDateOptions={specialDateOptions}
                                isOtherShow={isOtherShow}
                                actionTime={actionTime}
                                setEditedActionState={setEditedActionState}
                                setStartOpenDatePicker={setStartOpenDatePicker}
                                openStartDatePicker={openStartDatePicker}
                                isEditedActionTouched={isEditedActionTouched}
                                actionTimeOptions={actionTimeOptions}
                                setActionTime={setActionTime}
                                locationOptions={locationOptions}
                            />
                        )}
                    </>
                ))}

            {showCreateActionForm && (
                <>
                    <div className="c-section-header">
                        <h4>
                            {definedActions.length + 1}. {words && words['WEB.createPlan']}
                        </h4>
                    </div>

                    <Form onSubmit={handleSubmit}>
                        <div className="c-section-content-01">
                            <div className="c-section-content-01-A">
                                <div className="c-unit-01">
                                    <div className="c-unit-01-A">
                                        <FormControl variant="outlined" className="form-group-03">
                                            <label className="form-label">{words && words['WEB.planType']}</label>
                                            <Autocomplete
                                                fullWidth={true}
                                                noOptionsText={words && words['WEB.noDataInserted']}
                                                autoSelect={true}
                                                PopperComponent={CustomPopper2}
                                                closeIcon=""
                                                id="actionId"
                                                value={planValue}
                                                onChange={(e, val) => {
                                                    setState(prevState => ({
                                                        ...prevState,
                                                        actionId: val ? val.value : '',
                                                    }));
                                                    setPlanValue(val);
                                                }}
                                                getOptionLabel={(option: any) => option && option.label && option.label}
                                                options={specialDateOptions ? specialDateOptions : []}
                                                className={isTouched && !state.actionId ? 'autocomplete-03 not-valid' : 'autocomplete-03 '}
                                                renderInput={params => (
                                                    <>
                                                        <TextField {...params} placeholder={words && words['WEB.choose']} />
                                                        <SelectIcon className="icon-select" />
                                                    </>
                                                )}
                                            />
                                        </FormControl>
                                        {planValue?.label === (words && words['WEB.other']) && (
                                            <FormControl
                                                variant="outlined"
                                                className={isTouched && !state.otherActionDescription ? 'textfield-01 not-valid' : 'textfield-01'}>
                                                <label>{words && words['WEB.other']}</label>
                                                <TextField
                                                    id="outlined-helperText"
                                                    variant="outlined"
                                                    name="otherActionDescription"
                                                    value={state.otherActionDescription}
                                                    onChange={handleChange}
                                                />
                                            </FormControl>
                                        )}
                                    </div>
                                    <div className="c-unit-01-B">
                                        <label className="form-label">
                                            {words && words['WEB.planDate']}
                                            <span className="form-opsiyonel">({words && words['WEB.optional']})</span>
                                        </label>
                                        <CustomReactDatePicker
                                            name="actionDate"
                                            stateDate={state?.actionDate}
                                            isCreateActionPage
                                            setState={setState}
                                            isTouched={isTouched}
                                        />
                                    </div>
                                    <div className="c-unit-01-C">
                                        <FormControl variant="outlined" className="form-group-03">
                                            <label className="form-label">
                                                {words && words['WEB.planTime']}
                                                <span className="form-opsiyonel">({words && words['WEB.optional']})</span>
                                            </label>
                                            <Autocomplete
                                                fullWidth={true}
                                                autoSelect={true}
                                                PopperComponent={CustomPopper2}
                                                closeIcon=""
                                                id="actionTime"
                                                onChange={(e, val) =>
                                                    setState(prevState => ({
                                                        ...prevState,
                                                        actionTime: val ? val.label : '',
                                                    }))
                                                }
                                                getOptionLabel={(option: any) => option && option.label && option.label}
                                                options={actionTimeOptions ? actionTimeOptions : []}
                                                className="autocomplete-03 "
                                                renderInput={params => (
                                                    <>
                                                        <TextField {...params} placeholder={words && words['WEB.choose']} />
                                                        <SelectIcon className="icon-select" />
                                                    </>
                                                )}
                                            />
                                        </FormControl>
                                    </div>
                                </div>
                            </div>
                            <div className="c-section-content-01-B">
                                <div className="c-unit-01">
                                    <div className="c-unit-01-A">
                                        <FormControl variant="outlined" className="form-group-03">
                                            <label className="form-label">
                                                {words && words['WEB.planPlace']}{' '}
                                                <span className="form-opsiyonel">({words && words['WEB.optional']})</span>
                                            </label>
                                            <Autocomplete
                                                fullWidth={true}
                                                autoSelect={true}
                                                PopperComponent={CustomPopper2}
                                                closeIcon=""
                                                id="location"
                                                onChange={(e, val) =>
                                                    setState(prevState => ({
                                                        ...prevState,
                                                        location: val ? val.value : '',
                                                    }))
                                                }
                                                getOptionLabel={(option: any) => option && option.label && option.label}
                                                options={locationOptions ? locationOptions : []}
                                                className="autocomplete-03"
                                                renderInput={params => (
                                                    <>
                                                        <TextField {...params} placeholder={words && words['WEB.choose']} />
                                                        <SelectIcon className="icon-select" />
                                                    </>
                                                )}
                                            />
                                        </FormControl>
                                    </div>
                                    <div className="c-unit-01-B">
                                        <div className="c-unit-01-B-content form-group-03">
                                            <label>
                                                {words && words['WEB.note']}
                                                <span className="form-opsiyonel">({words && words['WEB.optional']})</span>
                                            </label>
                                            <textarea
                                                className="textarea-01"
                                                onChange={handleChange}
                                                name="description"
                                                placeholder={words && words['WEB.write'] + '...'}></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Form>
                </>
            )}

            <div className="c-section-content-02">
                {!showCreateActionForm && (
                    <div className="c-item-01">
                        <h3 className="c-unit-01-A">{words && words['WEB.createNewPlan']}</h3>
                        <a
                            href="#!"
                            onClick={() => {
                                setShowCreateActionForm(true);
                                setShowEditActionForm(false);
                            }}>
                            <svg className="c-unit-01-B" width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M31.6667 5H8.33333C6.49238 5 5 6.49238 5 8.33333V31.6667C5 33.5076 6.49238 35 8.33333 35H31.6667C33.5076 35 35 33.5076 35 31.6667V8.33333C35 6.49238 33.5076 5 31.6667 5Z"
                                    stroke="#D3D3D8"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path d="M20 13.3333V26.6666" stroke="#D3D3D8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M13.333 20H26.6663" stroke="#D3D3D8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </a>
                    </div>
                )}

                {showCreateActionForm && (
                    <div className="c-item-02">
                        <button className="c-unit-01-A" type="submit" onClick={handleSubmit}>
                            {words && words['WEB.SAVE']}
                        </button>
                        <svg className="c-unit-01-B" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9 18L15 12L9 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </div>
                )}
                {showEditActionForm && (
                    <div className="c-item-02">
                        <button className="c-unit-01-A" type="submit" onClick={handleEditedSubmit}>
                            {words && words['WEB.saveChanges']}
                        </button>
                        <svg className="c-unit-01-B" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9 18L15 12L9 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </div>
                )}
            </div>
        </>
    );
}
